import axios from "./../index";

// 相談サイドバー向けの自治体連携・頻回対応・ハイリスク疑い報告・リスクアセスメント履歴要約API。
// バックエンド: app/controllers/api/v1/users/face_sheet_history_summaries_controller.rb

const path = (userId: string) => `/api/v1/users/${userId}/face_sheet_history_summary`;

export type MunicipalCooperationHistory = {
  id: string;
  proposedAt: string | null;
  agreedLabel: string;
  cooperatedAt: string | null;
  partner: string;
  note: string;
};

export type FrequentUseResponseHistory = {
  id: string;
  respondedAt: string | null;
  responseLabel: string;
};

export type HighRiskReportHistory = {
  id: string;
  reportedAt: string | null;
  occupation: string;
  consultationType: string;
  reasons: string[];
  supplementNote: string;
};

export type RiskAssessmentSidebarHistory = {
  id: string;
  assessedAt: string | null;
  totalScore: number;
  notApplicableCount: number;
  unknownCount: number;
  positive: boolean;
  resultLabel: string;
  positiveItems: string[];
};

export type FaceSheetHistorySummary = {
  municipalCooperationHistories: MunicipalCooperationHistory[];
  frequentUseResponseHistories: FrequentUseResponseHistory[];
  highRiskReportHistories: HighRiskReportHistory[];
  riskAssessmentHistories: RiskAssessmentSidebarHistory[];
};

export default {
  fetchFaceSheetHistorySummary(userId: string, config: Record<string, unknown> = {}): Promise<FaceSheetHistorySummary> {
    return axios.get(path(userId), config).then((response) => response.data);
  }
};
